module.exports = function(app) {
	"use strict";
  app
  .directive('tinymceBasic',tinymceBasic);
	tinymceBasic.$inject = ['parseOptions','activeClass','$rootScope'];
  function tinymceBasic(parseOptions,activeClass,$rootScope) {
    return {
      restrict: 'E',
      scope: {
          parentObj:"=",
          update:"=",
          editorText: '=',
          order:'=',
          photo:'=',
          pollResultDisplay:'=',
          ratingResultDisplay:'=',
          galleryInPhoto:'=',
          attachToPost:'=',
          editorCharCount:'=',
          aiEditor:'=',
          editorModal:'=',
          customLink:'='
      },
      replace:true,
      template: require('./partial/tinymceBasic.html'),
      link: function(scope, element, attrs, ngModel) {
        scope.options = []
        if(scope.aiEditor) {
          scope.tinymceModel = scope.editorText.content;
          return;
        }
        if(attrs.options) {
          scope.options = attrs.options.split(',');
        }
        if(scope.options.length>0) {
          for(var i = 0; i<scope.options.length;i++) {
            scope[scope.options[i]] = true
          }
        }
        if(attrs.photo) {
          scope.photo = true;
        }
        if($rootScope.role_id == 'superadmin' || $rootScope.role_id == 'administrator') {
          scope.textModePermision = true;
        }
        var  parseOptionsFunc = parseOptions;
        scope.$watch(function(){
          return scope.update
        }, function(newValue, oldValue){
          if (newValue) {
            editorPopulate()
          }
        },true);
        function editorPopulate() {
          var editorContent = scope.editorText.content
          if(scope.photo) {
            editorContent.replace(/\[caption([^\]].*?)\]([^\]]*?)\[\/caption\]/g, function(all, attr, con) {
              var parseOptions = parseOptionsFunc(attr);
              if(parseOptions.signature_url) {
                var signatureUrl = parseOptions.signature_url
              } else {
                var signatureUrl = ''
              }
              editorContent = editorContent.replace( all,'<captionblock id="'+parseOptions.id+'" align="'+parseOptions.align+'" width="' +parseOptions.width +'" height="'+parseOptions.height+'" signature_url="'+ signatureUrl +'">'+con+'</captionblock>');
            });
          }
          if(scope.gallery) {
            editorContent.replace(/\[gallery([^\]].*?)\]/g, function(all, attr) {
              var parseOptions = parseOptionsFunc(attr);
              var title;
              if(parseOptions.title) {
                title =parseOptions.title
              } else {
                title=''
              }
              editorContent = editorContent.replace( all,'<galleryblock ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'">[gallery ids="'+parseOptions.ids+'" safe="'+parseOptions.safe+'" title="' + title +'"]</galleryblock>');
            });
          }
          if(scope.embed) {
            editorContent.replace(/\[embed([^\]].*?)\]([^\]]*?)\[\/embed\]/g, function(all, attr, con) {
              var parseOptions = parseOptionsFunc(attr);
              var type = parseOptions.type || parseOptions.src;
              editorContent = editorContent.replace( all,'<embedblock type="'+type+'">'+con+'</embedblock>');
            });
          }
          scope.tinymceModel = wpautop(editorContent);
        }
        editorPopulate()
        scope.editorChangePreviw = function(event, editorPreview) {
          activeClass.active(event);
          scope.$broadcast("change-editor",{editor_preview:editorPreview});
        }
        scope.pollModalObj = {
          addPollToEditorShow: false,
          cancelPollModal:function(){
            scope.pollModalShow=false;
            $rootScope.modalShow = false;
            scope.pollModalObj.addPollToEditorShow= false;
          }
        }
        scope.ratingModalObj = {
          addRatingToEditorShow: false,
          cancelRatingModal:function(){
            scope.ratingModalShow=false;
            $rootScope.modalShow = false;
            scope.ratingModalObj.addRatingToEditorShow= false;
          }
        }
        scope.addPollToEditor = function() {
          scope.pollModalObj.addPollToEditorShow= true;
          scope.pollModalShow=true;
          $rootScope.modalShow = true;
        } 
        scope.addRatingToEditor = function() {
          scope.ratingModalObj.addRatingToEditorShow= true;
          scope.ratingModalShow=true;
          $rootScope.modalShow = true;
        }
        scope.addBlogToEditor = function() {
          scope.blogModalObj.addBlogToEditorShow = true;
          scope.blogModalShow=true;
          $rootScope.modalShow = true;
        } 
        scope.blogModalObj = {
          addBlogToEditorShow:false,
          cancelBlogModal:function(){
            scope.blogModalShow=false;
            $rootScope.modalShow = false;
            scope.blogModalObj.addBlogToEditorShow = false
          }
        }
        scope.videoModalObj= {
          insertVideoToEditorModal:false,
          cancelVideoModal:function() {
            $rootScope.modalShow = false;
            scope.videoModalShow = false;
          }
        }
        scope.editImageModalObj ={
          editImageObj:'',
          editImagefromEditor:false,
          cancelImageModal:function() {
            scope.editImageModalObj.editImagefromEditor = false;
            $rootScope.modalShow = false;
          }
        }
        scope.imageModalObj = {
          insertMediatoEditor:false,
          insertGallery:false,
          galleryInPhoto:scope.galleryInPhoto,
          gallery_title:'',
          galleryUpdateIds:'',
          slideShowUnsafe:false,
          updateGallery:false,
          cancelImageModal:function() {
            $rootScope.modalShow = false;
            scope.mediaModal = false;
            scope.imageModalObj.insertMediatoEditor = false;
            scope.imageModalObj.insertGallery = false;
            scope.imageModalObj.updateGallery = false;
            scope.imageModalObj.gallery_title = '';
            scope.imageModalObj.slideShowUnsafe = false;
            scope.imageModalObj.galleryUpdateIds = '';
          },
          saveAttachments: function() {
            scope.$broadcast('attachment-save');
          }
        }
        scope.addMediatoEditor = function() {
          scope.mediaModal = true;
          scope.imageModalObj.insertMediatoEditor = true;
          $rootScope.modalShow = true;
        }
        scope.$on("edit-image",function(event, data) {
          scope.editImageModalObj.editImageObj = data.editImageObj;
          scope.editImageModalObj.editImagefromEditor = true;
          event.stopPropagation();
        });
        scope.addGallerytoEditor = function(update) {
          scope.mediaModal = true;
          scope.imageModalObj.insertGallery = true;
          $rootScope.modalShow = true;
          if(update) {
            scope.imageModalObj.updateGallery = true;
          }
        }
        scope.insertVideotoEditor = function() {
          $rootScope.modalShow = true;
          scope.videoModalShow = true;
          scope.videoModalObj.insertVideoToEditorModal = true;
        }
        scope.cancelVideoModal = function() {
          $rootScope.modalShow = false;
          scope.videoModalShow = false;
        }
      }
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/tinymceBasic/tinymceBasicDirective.js
// module id = 453
// module chunks = 0